import React, { useEffect, useState } from 'react'
import Title from 'antd/es/typography/Title';
import { Button, Card, Space, Table } from 'antd';
import { CheckOutlined, CloseOutlined, MinusCircleOutlined, PlusCircleOutlined, VerticalLeftOutlined, VerticalRightOutlined } from '@ant-design/icons';
import { isNullOrUndefined } from '../community-hats-js-library/utils/generalFunctions';
import * as libCon from "../community-hats-js-library/Constants.js"
import { RefParticipantsData } from '../hooks/DatasetHooks.js';
import { RefStoredValue } from '../hooks/GeneralStoreHooks.js';
import * as locCon from "../LocalConstants.js"
import { getMatches } from '../community-hats-js-library/utils/labFunctions.js';
import LocationPicker from './LocationPicker.js';
import { RefContextLanguage } from '../providers/LanguageProvider';
import { tField } from '../utils/translationFunctions';

const ParticipantCheckBox = ({ caseId, mappingDict, currentCaseId, setCurrentCaseId }) => {
    return (
        <div style={{
            marginLeft: "5px",
            marginRight: "5px",
            cursor: 'pointer',
            padding: "3px",
            border: caseId === currentCaseId ? '2px solid var(--border-color)' : "",
            borderRadius: '8px'
        }} onClick={() => setCurrentCaseId(caseId)}>
            {
                caseId in mappingDict
                    ? <CheckOutlined style={{ fontSize: 20, color: "var(--success-color-1)" }} />
                    : <CloseOutlined style={{ fontSize: 20, color: "var(--warning-color-1)" }} />
            }
            <p style={{ margin: "3px", fontSize: "18px" }}>{caseId}</p>

        </div>
    )

}


const CaseVisualizer = ({ caseId = null, metadataForFiles = null, mappingDict = null, moveCase = (i) => true }) => {


    const i18n = RefContextLanguage()

    const [currentCaseMetaInfo, setCurrentCaseMetaInfo] = useState({})
    const [mappedCase, setMappedCase] = useState({})


    useEffect(() => {
        if (isNullOrUndefined(caseId) || isNullOrUndefined(metadataForFiles) || !(caseId in metadataForFiles)) {
            setCurrentCaseMetaInfo({
                [libCon.ATF_LAB]: "---",
                [libCon.ATF_NAME]: "---",
                [libCon.ATF_AGE]: "---",
                [libCon.ATF_PHONE_NUMBER]: "---",
                [libCon.ATF_SEWA_ID]: "---",
            })
        }
        else {
            setCurrentCaseMetaInfo({
                [libCon.ATF_LAB]: metadataForFiles[caseId][libCon.ATF_LAB],
                [libCon.ATF_NAME]: metadataForFiles[caseId][libCon.ATF_NAME],
                [libCon.ATF_AGE]: metadataForFiles[caseId][libCon.ATF_AGE],
                [libCon.ATF_PHONE_NUMBER]: metadataForFiles[caseId][libCon.ATF_PHONE_NUMBER],
                [libCon.ATF_SEWA_ID]: metadataForFiles[caseId][libCon.ATF_SEWA_ID],
            })

        }


    }, [caseId, metadataForFiles])


    useEffect(() => {
        if (isNullOrUndefined(caseId)
            || isNullOrUndefined(metadataForFiles)
            || !(caseId in metadataForFiles)
            || isNullOrUndefined(mappingDict)
            || !(caseId in mappingDict)) {
            setMappedCase({
                [libCon.ATF_LOCATION]: "---",
                [libCon.ATF_NAME]: "---",
                [libCon.ATF_AGE]: "---",
                [libCon.ATF_PHONE_NUMBER]: "---",
                [libCon.ATF_SEWA_ID]: "---",
            })
        }
        else {
            setMappedCase({
                [libCon.ATF_LOCATION]: mappingDict[caseId][libCon.ATF_LOCATION],
                [libCon.ATF_NAME]: mappingDict[caseId][libCon.ATF_NAME],
                [libCon.ATF_AGE]: mappingDict[caseId][libCon.ATF_AGE],
                [libCon.ATF_PHONE_NUMBER]: mappingDict[caseId][libCon.ATF_PHONE_NUMBER],
                [libCon.ATF_SEWA_ID]: mappingDict[caseId][libCon.ATF_SEWA_ID],
            })

        }


    }, [caseId, metadataForFiles, mappingDict])


    return (
        <div>
            <Title level={4}>{`${i18n.t('currentCase')}: ${isNullOrUndefined(caseId) ? '---' : caseId}`}</Title>

            <Space>
                <VerticalRightOutlined style={{ fontSize: "4vh" }} onClick={() => moveCase(-1)} />

                <Card style={{ width: "30vw" }}
                    styles={{ header: { backgroundColor: "var(--primary-color-3)" }, }}
                    type="inner" size="small" title={i18n.t('case')} >

                    <p style={{ margin: "1px" }}><strong>{i18n.t('lab')}: </strong>{isNullOrUndefined(currentCaseMetaInfo[libCon.ATF_LAB]) ? "---" : currentCaseMetaInfo[libCon.ATF_LAB]}</p>
                    <p style={{ margin: "1px" }}><strong>{i18n.t('name')}: </strong>{isNullOrUndefined(currentCaseMetaInfo[libCon.ATF_NAME]) ? "---" : currentCaseMetaInfo[libCon.ATF_NAME]}</p>
                    <p style={{ margin: "1px" }}><strong>{i18n.t('age')}: </strong>{isNullOrUndefined(currentCaseMetaInfo[libCon.ATF_AGE]) ? "---" : currentCaseMetaInfo[libCon.ATF_AGE]}</p>
                    <p style={{ margin: "1px" }}><strong>{i18n.t('phoneNumber')}: </strong>{isNullOrUndefined(currentCaseMetaInfo[libCon.ATF_PHONE_NUMBER]) ? "---" : currentCaseMetaInfo[libCon.ATF_PHONE_NUMBER]}</p>
                    <p style={{ margin: "1px" }}><strong>{i18n.t('sewaId')}: </strong>{isNullOrUndefined(currentCaseMetaInfo[libCon.ATF_SEWA_ID]) ? "---" : currentCaseMetaInfo[libCon.ATF_SEWA_ID]}</p>

                </Card>
                <Card style={{ width: "30vw", border: caseId in mappingDict ? "" : "4px solid #b7362d" }}
                    styles={{
                        header: { backgroundColor: caseId in mappingDict ? "var(--success-color-1)" : "var(--warning-color-1)" },
                    }}
                    type="inner" size="small" title={i18n.t('mappedRecord')} >
                    <p style={{ margin: "1px" }}><strong>{i18n.t('location')}: </strong>{isNullOrUndefined(mappedCase[libCon.ATF_LOCATION]) ? "---" : mappedCase[libCon.ATF_LOCATION]}</p>
                    <p style={{ margin: "1px" }}><strong>{i18n.t('name')}: </strong>{isNullOrUndefined(mappedCase[libCon.ATF_NAME]) ? "---" : mappedCase[libCon.ATF_NAME]}</p>
                    <p style={{ margin: "1px" }}><strong>{i18n.t('age')}: </strong>{isNullOrUndefined(mappedCase[libCon.ATF_AGE]) ? "---" : mappedCase[libCon.ATF_AGE]}</p>
                    <p style={{ margin: "1px" }}><strong>{i18n.t('phoneNumber')}: </strong>{isNullOrUndefined(mappedCase[libCon.ATF_PHONE_NUMBER]) ? "---" : mappedCase[libCon.ATF_PHONE_NUMBER]}</p>
                    <p style={{ margin: "1px" }}><strong>{i18n.t('sewaId')}: </strong>{isNullOrUndefined(mappedCase[libCon.ATF_SEWA_ID]) ? "---" : mappedCase[libCon.ATF_SEWA_ID]}</p>

                </Card>
                <VerticalLeftOutlined style={{ fontSize: "4vh" }} onClick={() => moveCase(1)} />
            </Space>
        </div>

    )

}



function MatchChooser({ caseId = null, metadataForFiles = null, mappingDict = {}, setMappingDict = () => null, moveCase = (_) => true }) {


    const i18n = RefContextLanguage()

    const [selectedSewaIds, setSelectedSewaIds] = useState({})

    useEffect(() => {
        setSelectedSewaIds(Object.fromEntries(Object.keys(mappingDict).map(k => [mappingDict[k][libCon.ATF_SEWA_ID], k])))
    }, [mappingDict])


    const parseRecordIntoParticipant = (record) => {
        return ({
            [libCon.ATF_LOCATION]: record[libCon.ATF_LOCATION],
            [libCon.ATF_NAME]: record[libCon.ATF_TARGET_COMPLETE_NAME],
            [libCon.ATF_AGE]: record[libCon.ATF_TARGET_AGE],
            [libCon.ATF_PHONE_NUMBER]: record[libCon.ATF_TARGET_PHONE_NUMBER],
            [libCon.ATF_SEWA_ID]: record[libCon.ATF_TARGET_SEWA_ID],
            [libCon.ATF_CASE_ID]: caseId
        })
    }


    const GENERAL_COLUMNS = [
        {
            title: tField(i18n, libCon.ATF_LOCATION),
            dataIndex: libCon.ATF_LOCATION,
            align: 'center',
            width: 100,
        },
        {
            title: tField(i18n, libCon.ATF_SEWA_ID),
            dataIndex: libCon.ATF_TARGET_SEWA_ID,
            align: 'center',
            width: 100,
        },
        {
            title: tField(i18n, libCon.ATF_NAME),
            dataIndex: libCon.ATF_TARGET_COMPLETE_NAME,
            align: 'center',
            width: 100,
        },
        {
            title: i18n.t('globalScore'),
            dataIndex: libCon.ATF_SCORE,
            align: 'center',
            width: 100,
            sorter: (a, b) => isNullOrUndefined(a[libCon.ATF_SCORE]) ? -1 : isNullOrUndefined(b[libCon.ATF_SCORE]) ? 1 : a[libCon.ATF_SCORE] - b[libCon.ATF_SCORE],

        },
        {
            title: tField(i18n, libCon.ATF_SEWA_ID_SCORE),
            dataIndex: libCon.ATF_SEWA_ID_SCORE,
            align: 'center',
            width: 100,
            sorter: (a, b) => isNullOrUndefined(a[libCon.ATF_SEWA_ID_SCORE]) ? -1 : isNullOrUndefined(b[libCon.ATF_SEWA_ID_SCORE]) ? 1 : a[libCon.ATF_SEWA_ID_SCORE] - b[libCon.ATF_SEWA_ID_SCORE],
        },
        {
            title: tField(i18n, libCon.ATF_NAME_SCORE),
            dataIndex: libCon.ATF_NAME_SCORE,
            align: 'center',
            width: 100,
            sorter: (a, b) => isNullOrUndefined(a[libCon.ATF_NAME_SCORE]) ? -1 : isNullOrUndefined(b[libCon.ATF_NAME_SCORE]) ? 1 : a[libCon.ATF_NAME_SCORE] - b[libCon.ATF_NAME_SCORE],
        },
        {
            title: tField(i18n, libCon.ATF_PHONE_SCORE),
            dataIndex: libCon.ATF_PHONE_SCORE,
            align: 'center',
            width: 100,
            sorter: (a, b) => isNullOrUndefined(a[libCon.ATF_PHONE_SCORE]) ? -1 : isNullOrUndefined(b[libCon.ATF_PHONE_SCORE]) ? 1 : a[libCon.ATF_PHONE_SCORE] - b[libCon.ATF_PHONE_SCORE],

        },
        {
            title: tField(i18n, libCon.ATF_AGE_DIFF),
            dataIndex: libCon.ATF_AGE_DIFF,
            align: 'center',
            width: 100,
            sorter: (a, b) => isNullOrUndefined(a[libCon.ATF_AGE_DIFF]) ? -1 : isNullOrUndefined(b[libCon.ATF_AGE_DIFF]) ? 1 : a[libCon.ATF_AGE_DIFF] - b[libCon.ATF_AGE_DIFF],

        },
        {
            title: tField(i18n, libCon.ATF_AGE),
            dataIndex: libCon.ATF_TARGET_AGE,
            align: 'center',
            width: 100,
        },

        {
            title: tField(i18n, libCon.ATF_PHONE_NUMBER),
            dataIndex: libCon.ATF_TARGET_PHONE_NUMBER,
            align: 'center',
            width: 100,
        },
        {
            title: i18n.t('select'),
            dataIndex: libCon.ATF_TARGET_SEWA_ID,
            key: 14,
            align: 'center',
            width: 80,
            render: (val, record) => <Button type="primary" onClick={() => toggleMappingDict(record)}>{caseId in mappingDict && mappingDict[caseId][libCon.ATF_SEWA_ID] === record[libCon.ATF_TARGET_SEWA_ID] ? <MinusCircleOutlined /> : <PlusCircleOutlined />}</Button>,
        },
        {
            title: i18n.t('mappedCaseId'),
            dataIndex: libCon.ATF_TARGET_SEWA_ID,
            key: 14,
            align: 'center',
            width: 80,
            render: (val) => <p>{val in selectedSewaIds ? selectedSewaIds[val] : "---"}</p>
        }

    ]

    const toggleMappingDict = (record) => {
        // Already selected
        if (caseId in mappingDict && mappingDict[caseId][libCon.ATF_SEWA_ID] === record[libCon.ATF_TARGET_SEWA_ID]) {
            delete mappingDict[caseId]
            setMappingDict({ ...mappingDict })
        }
        else {
            // Checks if the participant is already added
            if (record[libCon.ATF_TARGET_SEWA_ID] in selectedSewaIds)
                delete mappingDict[selectedSewaIds[record[libCon.ATF_TARGET_SEWA_ID]]]

            setMappingDict({ ...mappingDict, [caseId]: parseRecordIntoParticipant(record) })

            moveCase(1)

        }

    }


    const [participantStatus, participants] = RefParticipantsData()
    const location = RefStoredValue(locCon.PROJECT_LOCATION)


    const [closestMatches, setClosestMatches] = useState([])

    const [currentPage, setCurrentPage] = useState(1);


    useEffect(() => {

        if (participantStatus !== libCon.OK
            || isNullOrUndefined(caseId)
            || isNullOrUndefined(metadataForFiles)
            || !(caseId in metadataForFiles)) {
            setClosestMatches([])
            return
        }


        let sortedMatches = getMatches(metadataForFiles[caseId], participants, location)

        sortedMatches = sortedMatches.map(ob => { return ({ ...metadataForFiles[caseId], ...ob }) })

        setClosestMatches(sortedMatches)

        setCurrentPage(1)

    }, [metadataForFiles, caseId, participants, location, participantStatus])


    return (
        <div style={{ marginTop: "0.5vh", minWidth: "90vw" }}>
            <Title level={4}>{i18n.t('matchChooser')}</Title>

            <div style={{ marginTop: "5px" }}>
                {
                    closestMatches.length > 0
                        ? <Table dataSource={closestMatches}
                            columns={GENERAL_COLUMNS}
                            size="small"
                            scroll={{ x: 'max-content', y: window.innerHeight * 0.65 }}
                            style={{ fontSize: '12px' }}
                            pagination={{
                                current: currentPage, // ← set current page
                                pageSize: 25,
                                onChange: (page) => setCurrentPage(page), // ← update page on user click
                            }}
                            rowClassName={(record) => {
                                return caseId in mappingDict && mappingDict[caseId][libCon.ATF_SEWA_ID] === record[libCon.ATF_TARGET_SEWA_ID] ? "row-selected" : record[libCon.ATF_TARGET_SEWA_ID] in selectedSewaIds ? "row-used" : '';
                            }} />
                        : <div></div>
                }
            </div>
        </div>
    )

}


function MatchLabResults({ metadataForFiles, mappingDict, setMappingDict }) {

    const i18n = RefContextLanguage()

    const [currentCaseId, setCurrentCaseId] = useState(() => !isNullOrUndefined(metadataForFiles) && Object.keys(metadataForFiles).length > 0 ? Object.keys(metadataForFiles)[0] : null)

    const moveCase = (offset) => {

        if (isNullOrUndefined(metadataForFiles) || Object.keys(metadataForFiles).length === 0)
            return

        const array = Object.keys(metadataForFiles)
        const index = array.indexOf(currentCaseId);
        let newIndex = index + offset;

        if (newIndex < 0)
            newIndex += array.length

        if (index > -1) {
            setCurrentCaseId(array[newIndex % array.length])
        }
    }

    return (
        <div style={{ maxWidth: "90vw" }}>
            <Title level={3}>{i18n.t('mapRecords')}</Title>
            {/* Location Picker */}
            <div style={{ marginBottom: "10px" }}>
                <LocationPicker includeAll={true} />
            </div>
            <div className='horizontalSection'>
                {
                    Object.keys(metadataForFiles).map(k => <ParticipantCheckBox key={k} caseId={k} mappingDict={mappingDict} currentCaseId={currentCaseId} setCurrentCaseId={setCurrentCaseId} />)
                }
            </div>


            <CaseVisualizer caseId={currentCaseId}
                moveCase={moveCase}
                metadataForFiles={metadataForFiles}
                mappingDict={mappingDict} />


            {/* Name Matcher Results */}
            <MatchChooser caseId={currentCaseId}
                metadataForFiles={metadataForFiles}
                mappingDict={mappingDict}
                setMappingDict={setMappingDict}
                moveCase={moveCase} />



        </div>
    )
}

export default MatchLabResults